export const POLL_INTERVAL = 1000;
export const DEFAULT_PAGE_SIZE = 10;
export const MAX_PROFILE_COUNT = 50000;

export const COMPLETION_STATUS = {
    FULL_SUCCESS: 'full-success',
    PARTIAL_SUCCESS: 'partial-success',
    FULL_ERROR: 'full-error',
};

export const MODAL_STATE = {
    IDLE: 'idle',
    LOADING: 'loading',
    NO_DATA: 'no-data',
    READY: 'ready',
    UPDATING: 'updating',
    COMPLETED: 'completed',
    SUMMARY: 'summary',
};

export const IMPORT_JOB_STATE = {
    IDLE: 'idle',
    CREATING: 'creating',
    RUNNING: 'running',
    COMPLETED: 'completed',
    ERROR: 'error',
    CANCELLED: 'cancelled',
};

export const ROW_STATUS = {
    MISSING: 'missing',
    MISMATCH: 'mismatch',
    SUCCESS: 'success',
    ERROR: 'error',
};

export const FIELD_TYPE = {
    SINGLE: 'single',
    NESTED: 'nested',
};

export const NOTIFICATION_VARIANT = {
    INFO: 'info',
    WARNING: 'warning',
    DANGER: 'danger',
    SUCCESS: 'success',
};

export const FIELD_TO_PROFILE_FIELD = {
    PHONE_NUMBER: '__profile_phone__',
    WEBSITE_LINK: '__profile_website__',
    BUSINESS_HOURS: '__profile_business_hr__',
    DESCRIPTION: '__profile_description__',
    UNKNOWN: '',
};

export const FIELD_TO_VALUES_KEY = {
    PHONE_NUMBER: '__profile_places__0__profile_phone__0_number',
    WEBSITE_LINK: '__profile_places__0__profile_website__0_url',
    BUSINESS_HOURS: '__profile_places__0__profile_business_hr__0_',
    DESCRIPTION: '__profile_description__',
    UNKNOWN: '',
};

export const FIELD_CONFIG = {
    PHONE_NUMBER: { icon: 'icon-phone', type: FIELD_TYPE.SINGLE },
    WEBSITE_LINK: { icon: 'icon-address-card', type: FIELD_TYPE.SINGLE },
    BUSINESS_HOURS: { icon: 'icon-clock', type: FIELD_TYPE.NESTED },
    DESCRIPTION: { icon: 'icon-edit', type: FIELD_TYPE.SINGLE },
    UNKNOWN: { icon: '', type: FIELD_TYPE.SINGLE },
};

export const VALID_FIELDS = ['PHONE_NUMBER', 'WEBSITE_LINK', 'BUSINESS_HOURS', 'DESCRIPTION'];

export const WEEKDAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export const BUSINESS_HOURS_CLOSED = 'Closed';
export const BUSINESS_HOURS_TYPE_MAIN = 'Main';
export const PHONE_TYPE_MAIN = 'Local';
export const WEBSITE_TYPE_HOMEPAGE = 'Homepage';

export const LOCATION_UID_KEY = '__profile_location_uid__';
export const LOCATION_NAME_KEY = '__profile_external_name__';
export const BUSINESS_HOUR_PREFIX = '__profile_places__0__profile_business_hr__0_';
export const PROFILE_PLACES_PREFIX = '__profile_places__0__';

export const AUDIT_LOCATION_UID_KEY = '__audit_location_uid__';
export const AUDIT_SOURCE_ID_KEY = '__audit_source_id__';
export const DATA_FIELDS_MISSING_KEY = '__data_fields_missing_in_profile__';
export const GOOGLE_PLACES_SOURCE = 'GOOGLE_PLACES';

export const ICON_PATHS = {
    LOCATION: '/rsrc2/images/directory/listings/notifications/location.svg',
    GOOGLE: '/rsrc2/images/directory/listings/notifications/google.svg',
    REPUTATION: '/rsrc2/images/directory/listings/notifications/reputation.svg',
    BULB: '/rsrc2/images/directory/listings/notifications/bulb.svg',
};

export const TRANSLATION_NAMESPACE = 'listings/notifications';
